import { Product } from '../swagger';

/**
 * Customer-facing state of a health checkup's e-referral, as derived by the
 * engine (`calculateReferral` in `shared/entities/product.referral.ts`).
 */
export enum ReferralStatus {
  /** Ordered, not yet confirmed by the lab — or being retried. */
  PENDING = 'pending',
  /** Live at the lab: the customer can walk in and give blood. */
  ACTIVE = 'active',
  /** Sample taken, results on their way. */
  SAMPLED = 'sampled',
  /** All results are in. */
  COMPLETED = 'completed',
  /** Sending the referral failed; needs us to act. */
  FAILED = 'failed',
  /** Withdrawn (product cancelled). */
  CANCELLED = 'cancelled',
}

export interface ProductReferral {
  status: ReferralStatus;
  /** ISO date the referral was sent to the lab. */
  createdAt?: string;
  /** Sampling town the customer picked when ordering. */
  city?: string;
}

/**
 * The engine serves `Product.referral`, but `src/swagger` is generated and its
 * regeneration needs a running engine (CLAUDE.md → Regenerating the API
 * client), so the model does not carry the field yet. Read it through here.
 *
 * After the next `pnpm generate` this can go: the type above becomes
 * `ProductReferral` from `../swagger` and callers use `product.referral`.
 */
export const getReferral = (product: Product): ProductReferral | undefined =>
  (product as Product & { referral?: ProductReferral }).referral;
